const locations = {
    alabama: require('images/admin/campaign_wrap_up/locations/alabama.png'),
    alaska: require('images/admin/campaign_wrap_up/locations/alaska.png'),
    arizona: require('images/admin/campaign_wrap_up/locations/arizona.png'),
    arkansas: require('images/admin/campaign_wrap_up/locations/arkansas.png'),
    california: require('images/admin/campaign_wrap_up/locations/california.png'),
    colorado: require('images/admin/campaign_wrap_up/locations/colorado.png'),
    connecticut: require('images/admin/campaign_wrap_up/locations/connecticut.png'),
    delaware: require('images/admin/campaign_wrap_up/locations/delaware.png'),
    florida: require('images/admin/campaign_wrap_up/locations/florida.png'),
    georgia: require('images/admin/campaign_wrap_up/locations/georgia.png'),
    hawaii: require('images/admin/campaign_wrap_up/locations/hawaii.png'),
    idaho: require('images/admin/campaign_wrap_up/locations/idaho.png'),
    illinois: require('images/admin/campaign_wrap_up/locations/illinois.png'),
    indiana: require('images/admin/campaign_wrap_up/locations/alabama.png'),
    iowa: require('images/admin/campaign_wrap_up/locations/iowa.png'),
    kansas: require('images/admin/campaign_wrap_up/locations/kansas.png'),
    kentucky: require('images/admin/campaign_wrap_up/locations/kentucky.png'),
    louisiana: require('images/admin/campaign_wrap_up/locations/louisiana.png'),
    maine: require('images/admin/campaign_wrap_up/locations/maine.png'),
    maryland: require('images/admin/campaign_wrap_up/locations/maryland.png'),
    massachusetts: require('images/admin/campaign_wrap_up/locations/massachusetts.png'),
    michigan: require('images/admin/campaign_wrap_up/locations/michigan.png'),
    minnesota: require('images/admin/campaign_wrap_up/locations/minnesota.png'),
    mississippi: require('images/admin/campaign_wrap_up/locations/mississippi.png'),
    missouri: require('images/admin/campaign_wrap_up/locations/missouri.png'),
    montana: require('images/admin/campaign_wrap_up/locations/montana.png'),
    nebraska: require('images/admin/campaign_wrap_up/locations/nebraska.png'),
    nevada: require('images/admin/campaign_wrap_up/locations/nevada.png'),
    'new hampshire': require('images/admin/campaign_wrap_up/locations/newhampshire.png'),
    'new jersey': require('images/admin/campaign_wrap_up/locations/newjersey.png'),
    'new mexico': require('images/admin/campaign_wrap_up/locations/newmexico.png'),
    'new york': require('images/admin/campaign_wrap_up/locations/newyork.png'),
    'north carolina': require('images/admin/campaign_wrap_up/locations/northcarolina.png'),
    'north dakota': require('images/admin/campaign_wrap_up/locations/northdakota.png'),
    ohio: require('images/admin/campaign_wrap_up/locations/ohio.png'),
    oklahoma: require('images/admin/campaign_wrap_up/locations/oklahoma.png'),
    oregon: require('images/admin/campaign_wrap_up/locations/oregon.png'),
    pennsylvania: require('images/admin/campaign_wrap_up/locations/pennsylvania.png'),
    'rhode island': require('images/admin/campaign_wrap_up/locations/rhodeisland.png'),
    'south carolina': require('images/admin/campaign_wrap_up/locations/southcarolina.png'),
    'south dakota': require('images/admin/campaign_wrap_up/locations/southdakota.png'),
    tennessee: require('images/admin/campaign_wrap_up/locations/tennessee.png'),
    texas: require('images/admin/campaign_wrap_up/locations/texas.png'),
    utah: require('images/admin/campaign_wrap_up/locations/utah.png'),
    vermont: require('images/admin/campaign_wrap_up/locations/vermont.png'),
    virginia: require('images/admin/campaign_wrap_up/locations/virginia.png'),
    washington: require('images/admin/campaign_wrap_up/locations/washington.png'),
    'washington dc': require('images/admin/campaign_wrap_up/locations/washingtondc.svg'),
    'west virginia': require('images/admin/campaign_wrap_up/locations/westvirginia.png'),
    wisconsin: require('images/admin/campaign_wrap_up/locations/wisconsin.png'),
    wyoming: require('images/admin/campaign_wrap_up/locations/wyoming.png'),
    world: require('images/admin/campaign_wrap_up/locations/world.png')
};

export default locations;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/analytics_shared/states_countries_info.js